import React from 'react';
import { Property } from '../../services/api';
import { Section } from './Section';
import { ConsentLines, InquiryDone } from '../inquiry/InquiryParts';
import type { ContactPhone } from '../../domain/inquiry/resolveContactPhone';

type ContactFormState = { name: string; phone1: string; phone2: string };

// 6. 분양 문의 — 컨택트폼 (운영 voonang.com/property/2749 동등)
//   useContactForm: POST /api/properties/{id}/contact/ + Meta Pixel 추적.
//   사용자 피드백 2026-05-22: 사이드 현장은 컨택트폼 숨김.
export const InquirySection: React.FC<{
  property: Property;
  refCb?: (el: HTMLElement | null) => void;
  contactForm: ContactFormState;
  setContactForm: React.Dispatch<React.SetStateAction<ContactFormState>>;
  formSubmitting: boolean;
  handleContactSubmit: (e: React.FormEvent) => void;
  /** v2 S6 — 제출 성공 시 접수 완료 화면 (2026-09-22 v2h) */
  submittedPhone?: string | null;
  /** 접수 완료 화면의 '지금 바로 통화' 번호 (resolveContactPhone) */
  phone?: ContactPhone | null;
}> = ({ property, refCb, contactForm, setContactForm, formSubmitting, handleContactSubmit, submittedPhone, phone }) => (
  <Section
    id="inquiry"
    refCb={refCb}
    eyebrow={
      property.is_pre_registration ? '관심고객 사전등록'
      : property.status === '분양예정' ? '관심고객 등록'
      : '분양 문의'
    }
  >
    <div>
      {submittedPhone ? (
        <InquiryDone customerPhone={submittedPhone} propertyTitle={property.title} phone={phone} />
      ) : (
      /* 폼 박스 — 전체 너비 (전화 박스는 sticky CTA 에서 처리) */
      <form
        method="post"
        onSubmit={handleContactSubmit}
        className="flex flex-col gap-3 rounded-ca-2xl border border-ca-line bg-frame p-5 md:p-6"
      >
        <p className="text-[18.75px] font-bold text-ink">
          {property.is_pre_registration ? '오픈 시 우선적으로 연락드리겠습니다.'
            : property.status === '분양예정' ? '분양소식을 알려드리겠습니다.'
            : '모델하우스 직원이 바로 연락드립니다.'}
        </p>

        <div className="flex flex-col gap-2.5">
          <label className="text-[11.5px] font-bold text-muted">
            이름 <span className="text-accent">*</span>
          </label>
          <input
            type="text"
            placeholder="이름을 입력하세요"
            value={contactForm.name}
            onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
            required
            disabled={formSubmitting}
            className="rounded-ca-md border border-ca-line bg-white px-3.5 py-3 text-[14px] text-ink outline-none transition-colors placeholder:text-mute2 focus:border-accent disabled:opacity-60"
          />
        </div>

        <div className="flex flex-col gap-2.5">
          <label className="text-[11.5px] font-bold text-muted">
            연락처 <span className="text-accent">*</span>
          </label>
          <div className="flex items-center gap-1.5">
            <span className="rounded-ca-md border border-ca-line bg-block px-3 py-3 text-[14px] font-bold text-ink">010</span>
            <span className="text-muted">-</span>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              placeholder="0000"
              value={contactForm.phone1}
              onChange={(e) =>
                setContactForm({ ...contactForm, phone1: e.target.value.replace(/[^0-9]/g, '') })
              }
              required
              disabled={formSubmitting}
              className="w-full min-w-0 rounded-ca-md border border-ca-line bg-white px-3 py-3 text-center text-[14px] tabular-nums text-ink outline-none transition-colors placeholder:text-mute2 focus:border-accent disabled:opacity-60"
            />
            <span className="text-muted">-</span>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              placeholder="0000"
              value={contactForm.phone2}
              onChange={(e) =>
                setContactForm({ ...contactForm, phone2: e.target.value.replace(/[^0-9]/g, '') })
              }
              required
              disabled={formSubmitting}
              className="w-full min-w-0 rounded-ca-md border border-ca-line bg-white px-3 py-3 text-center text-[14px] tabular-nums text-ink outline-none transition-colors placeholder:text-mute2 focus:border-accent disabled:opacity-60"
            />
          </div>
        </div>

        <ConsentLines disabled={formSubmitting} />

        <button
          type="submit"
          disabled={formSubmitting}
          className="mt-1 rounded-ca-md bg-accent px-4 py-3.5 text-[14px] font-extrabold text-white shadow-ca-cta transition-colors hover:bg-accent-dark disabled:cursor-not-allowed disabled:opacity-60"
        >
          {formSubmitting ? '전송 중…'
            : property.is_pre_registration ? '사전등록 신청하기'
            : property.status === '분양예정' ? '관심고객 등록하기'
            : '상담 신청하기'}
        </button>
      </form>
      )}
    </div>
  </Section>
);
